var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      staticClass: "avatar-uploader",
      style: "width:" + _vm.size + ";height:" + _vm.size + ";",
      attrs: {
        action: "",
        "show-file-list": false,
        "on-change": _vm.handleFileChange,
        "http-request": _vm.uploadFile,
        "on-success": _vm.handleAvatarSuccess,
        "before-upload": _vm.beforeAvatarUpload,
      },
    },
    [
      _vm.loading
        ? [
            _c("el-progress", {
              attrs: {
                "show-text": false,
                "stroke-width": 1,
                percentage: _vm.process,
                color: "#3a416f",
              },
            }),
          ]
        : [
            _vm.url
              ? _c("el-image", {
                  staticClass: "avatar",
                  attrs: { src: _vm.url, fit: "contain" },
                })
              : _c("span", { staticClass: "up-icon" }, [_vm._v("+")]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }